import { type SupportedChain } from '@pkg/types';
import { roundToCommonDecimals } from '@pkg/utils';

export function guessBlockchain(blockchain?: string | null): SupportedChain {
    const safeBlockchain = blockchain ?? '';
    const formatted = safeBlockchain.toLowerCase();

    if (formatted.includes('apt')) return 'aptos';
    if (formatted.includes('poly')) return 'polygon';

    return 'ethereum';
}

export function percentFloat(from = 0, to = 0) {
    const difference = from / to;
    const safeDiff = Number.isFinite(difference) ? difference : 0;
    const result = safeDiff * 100;

    return roundToCommonDecimals(result);
}
